export const FETCH_OWNER_LIST_REQUEST =
    'FETCH_OWNER_LIST_REQUEST';
export const FETCH_OWNER_LIST_SUCCESS =
    'FETCH_OWNER_LIST_SUCCESS';
export const FETCH_OWNER_LIST_FAILURE =
    'FETCH_OWNER_LIST_FAILURE';


export const DELETE_OWNER_REQUEST = 'DELETE_OWNER_REQUEST';
export const DELETE_OWNER_SUCCESS = 'DELETE_OWNER_SUCCESS';
export const DELETE_OWNER_FAILURE = 'DELETE_OWNER_FAILURE';
export const UPDATE_OWNER_REQUEST = 'UPDATE_OWNER_REQUEST';
export const UPDATE_OWNER_SUCCESS = 'UPDATE_OWNER_SUCCESS';
export const UPDATE_OWNER_FAILURE = 'UPDATE_OWNER_FAILURE';
export const CREATE_OWNER_REQUEST = 'CREATE_OWNER_REQUEST';
export const CREATE_OWNER_SUCCESS = 'CREATE_OWNER_SUCCESS';
export const CREATE_OWNER_FAILURE = 'CREATE_OWNER_FAILURE';